module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/bg-success.d3dd593a.png";